package com.appsyde.shared.modules.ticket.domain.usecase


import com.appsyde.shared.modules.ticket.domain.model.SendResult
import com.appsyde.shared.modules.ticket.domain.model.OutboundAttachmentForSend
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class SendReplyUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(
        ticketId: String,
        body: String,
        subject: String? = null,
        to: String? = null,
        attachments: List<OutboundAttachmentForSend> = emptyList()
    ): SendResult {
        return repo.sendReply(
            ticketId = ticketId,
            body = body,
            subject = subject,
            to = to,
            attachments = attachments
        )
    }
}
